export const SERVICE_ID = process.env.REACT_APP_SERVICE_ID;
export const TEMPLATE_ID = process.env.REACT_APP_TEMPLATE_ID;
export const PUBLIC_KEY = process.env.REACT_APP_PUBLIC_KEY;
export const CALENDY_URL = process.env.REACT_APP_CALENDY_URL;
